import { IS_UI_ONLY_MODE } from '../config/electron';

export const ENV = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production'
};
type Environment = typeof ENV.DEVELOPMENT | typeof ENV.PRODUCTION;
const resolveEnv = (env?: string): Environment => (env === ENV.PRODUCTION ? ENV.PRODUCTION : ENV.DEVELOPMENT);

export const API_BASE_URLS = {
    [ENV.DEVELOPMENT]: 'https://api-dev.eu.i2x.ai',
    [ENV.PRODUCTION]: 'https://api.eu.i2x.ai'
};

export const LOGGER_API_KEYS = {
    [ENV.DEVELOPMENT]: 'f069ff53d14d34fc1f0dc6bf1234faf2c479e6d3',
    [ENV.PRODUCTION]: 'e10a4f5585a9c3eb16381e646cf691b18b4bc047'
};

export const RECOGNITION_ENDPOINT = {
    [ENV.PRODUCTION]: {
        protocol: 'wss',
        host: IS_UI_ONLY_MODE ? 'api.eu.i2x.ai/asr/v2' : 'api.eu.i2x.ai/asr/v1'
    },
    [ENV.DEVELOPMENT]: {
        protocol: 'wss',
        host: IS_UI_ONLY_MODE ? 'api-dev.eu.i2x.ai/asr/v2' : 'api-dev.eu.i2x.ai/asr/v1'
    }
};

export const CORE_DASHBOARD_URLS = {
    [ENV.DEVELOPMENT]: 'https://insights-dev.i2x.ai',
    [ENV.PRODUCTION]: 'https://insights.i2x.ai'
};

const VOICE_ROUTER_URLS = {
    [ENV.DEVELOPMENT]: 'wss://bot.ml4.i2x.ai/simulator/v2-dev',
    [ENV.PRODUCTION]: 'wss://bot.ml4.i2x.ai/simulator/v2'
};

const getBases = (env: Environment = ENV.DEVELOPMENT) => {
    return API_BASE_URLS[env];
};

export const getAsrEndpoint = (env = process.env.NODE_ENV || ENV.DEVELOPMENT) => {
    return RECOGNITION_ENDPOINT[resolveEnv(env)];
};

export const getDashboardLink = (env = process.env.NODE_ENV || ENV.DEVELOPMENT) => {
    return CORE_DASHBOARD_URLS[resolveEnv(env)];
};

const currentEnv = resolveEnv(process.env.NODE_ENV);
export const BASE_URL = getBases(currentEnv);
export const LOGGER_API_KEY = LOGGER_API_KEYS[currentEnv];
export const CALL_EVENT_URL = `${getBases(currentEnv)}/events/v1/calls`;
export const VOICE_ROUTER_URL = VOICE_ROUTER_URLS[currentEnv];
